






























































import {Component, Prop, Vue} from 'vue-property-decorator'
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import SchedulesStore from "@/store/modules/SchedulesStore";


@Component({
    components: {
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
    },
})
export default class DeleteScheduleDialog extends Vue {
    @Prop() private scheduleId!: number;
    @Prop() private selected!: string;

    get schedule(): CMS.Schedule {
        return SchedulesStore.scheduleById[this.scheduleId] || {};
    }

    get weeks(): number[] {
        return this.schedule.weeks || [];

    }
}
